import { Skeleton } from "@/components/radix/skeleton";
import { Card, CardContent } from "@/components/rac/card";

// Property List Skeleton Component
export function ListSkeleton({ count = 5 }: { count?: number }) {
	return (
		<div className="grid grid-cols-1 lg:grid-cols-2 gap-4 w-full px-2">
			{Array.from({ length: count }).map((_, index) => (
				<div key={index} className="w-full min-h-[370px]">
					<Card className="bg-white/80 hover:bg-white h-full transition-all duration-300 group/card cursor-pointer p-0 flex flex-col gap-2 relative">
						{/* Image Container */}
						<div className="relative overflow-hidden rounded-t-xl aspect-[4/3]">
							<Skeleton className="w-full h-full" />

							{/* Property info overlay skeleton */}
							<div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-gray-100/80 via-gray-50/60 to-transparent p-4 pt-8">
								<div className="flex items-center justify-between">
									<div className="flex-1">
										<Skeleton className="h-5 w-24 bg-gray-200/60 mb-1" />
										<Skeleton className="h-3 w-16 bg-gray-200/60" />
									</div>
									<div className="text-right">
										<Skeleton className="h-3 w-20 bg-gray-200/60 mb-1" />
										<Skeleton className="h-3 w-16 bg-gray-200/60" />
									</div>
								</div>
							</div>
						</div>

						{/* Content */}
						<CardContent className="px-2 flex-1 flex flex-col pb-1">
							{/* Main content layout */}
							<div className="mb-1 flex items-start justify-between gap-2">
								{/* Left column: Title and bedroom details */}
								<div className="flex flex-col flex-1 min-w-0">
									<Skeleton className="h-4 w-3/4 mb-2" />

									{/* Property details icons row */}
									<div className="flex gap-4 text-gray-600 text-sm">
										{/* Property Type Icon */}
										<div className="flex border-r border-gray-200 pr-3">
											<Skeleton className="h-4 w-4" />
										</div>

										{/* Bedroom */}
										<div className="flex items-center gap-1">
											<Skeleton className="h-4 w-4" />
											<Skeleton className="h-3 w-4" />
										</div>

										{/* Bathroom */}
										<div className="flex items-center gap-1">
											<Skeleton className="h-4 w-4" />
											<Skeleton className="h-3 w-4" />
										</div>

										{/* Facing */}
										<div className="flex items-center gap-1">
											<Skeleton className="h-4 w-4" />
											<Skeleton className="h-3 w-6" />
										</div>

										{/* Parking */}
										<div className="flex items-center gap-1">
											<Skeleton className="h-4 w-4" />
											<Skeleton className="h-3 w-4" />
										</div>
									</div>
								</div>

								{/* Right column: Shortlist button */}
								<div className="flex flex-col items-center">
									<Skeleton className="h-10 w-10 rounded-full" />
								</div>
							</div>
						</CardContent>
					</Card>
				</div>
			))}
		</div>
	);
}
